import { SVGProps } from 'react'

function ArrowBack(props: JSX.IntrinsicAttributes & SVGProps<SVGSVGElement>) {
  return (
    <svg width={24} height={24} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M23.25 12H.75M11.25 1.5.75 12l10.5 10.5"
        stroke="#7B829D"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

ArrowBack.defaultProps = { role: 'graphics-document' }

export default ArrowBack
